module.exports = __webpack_public_path__ + "static/img/logos.7dbc2b3a.png";